<template>
  <div class="row">

    <!-- FILTER BAR -->
    <div class="col-12 mb-3 no-print">
            <div class="d-flex align-items-center mt-2">
        <h5 class="mb-0 text-primary"><i class="fas fa-id-card-alt  text-primary"></i> ID Card List</h5>
      </div>
      <hr />
      <div class="row g-3 align-items-end">
<div class="col-md-4">
  <label class="form-label">
    Class <sup><span class="text-danger font-12">*</span></sup> :
  </label>

  <div class="dropdown">
    <button
      class="form-select form-select-sm rounded dropdown-toggle w-100 dropdown-a"
      type="button"
      data-bs-toggle="dropdown"
      aria-expanded="false"
    >
{{ classList.find(c => c._id === clsID)?.name || '' }}
    </button>

    <ul class="dropdown-menu w-100 scrollable-menu">
<li v-for="item in uniqueClassList" :key="item._id">
  <a
    class="dropdown-item"
    href="#"
    @click.prevent="selectClass(item)"
  >
    {{ item.name }}
  </a>
</li>

    </ul>
  </div>
</div>


        <div class="col-md-4">
          <label class="form-label">Section</label>
          <select
            v-model="sectionID"
            class="form-select form-select-sm" style="cursor: pointer;"
          >
            <option value="">All</option>
            <option v-for="s in secList" :key="s._id" :value="s._id">
              {{ s.Name }}
            </option>
          </select>
        </div>

        <div class="col-md-4">
            <div class="d-flex gap-2">

          <button class="btn btn-sm btn-success me-1" @click="loadStudents">
           <i class="fas fa-search text-white"></i> Go
          </button>
            <button class="btn btn-sm btn-soft-dark" type="button" @click="reset" ><i class="fas fa-times-circle  me-1"></i> Cancel </button>
            </div>
        </div>
<ul
  v-if="Object.keys(errors).length > 0"
  class="text-danger ps-3"
>
  <li v-for="(err, key) in errors" :key="key">
    {{ err }}
  </li>
</ul>
      </div>
    </div>

    <!-- ACTIONS -->
    <div class="col-8 d-flex justify-content-end gap-2 mb-2 no-print" v-if="students.length">
      <button class="btn btn-lg" @click="printSectionOnly">
        <i class="fa fa-print text-primary cursor-pointer fs-4"></i> 
      </button>
      <button class="btn btn-lg" @click="downloadImage">
        <i class="fa fa-download fs-4 cursor-pointer"></i>
      </button>
    </div>

    <!-- PRINT TARGET -->
    <div class="col-12" v-if="students.length">
      <div class=" print-target" ref="printSection">
<div
  v-for="(page, pIndex) in studentPages"
  :key="pIndex"
    class="a4-sheet"
>
  <div class="row">
    <div
      v-for="stu in page"
      :key="stu._id"
      class="col-4 mb-4 idcard-col"
    >
        
     <div class="scale-wrap">
<div v-if="primaryCard === 'idCard1'" class="id-card">
  <div class="wave-top" style="width:auto;">
    <div
      v-if="cardsReady"
      class="sidebar"
  :style="{
    position: 'absolute',
    left: '0',
    top: '0',
    height: '420px',
    width: '30px',
    background: sidebarBg,
    backgroundSize: 'cover'
  }"
  >
  </div>
  </div>

  <div class="card-content2 text-center">
    <div class="d-flex align-items-start mt-2 start-a">
      <img :src="getUrl(profile.Image, logo_default)" alt="School Logo" class="logo ms-2 mt-2" width="55" height="55" />
      <div class="text-start w-100 mt-2 me-1">
        <p class="text-center fw-bold mb-0 me-1" >{{ profile.Name }}</p>
        <p class="text-center me-1 small mb-0"  >{{ profile.Address }}</p>
      </div>
    </div>

    <img
      :src="getUrl(stu.image, profile_default)"
      :class="[Obj1.idCardData?.imageShape === 'circle' ? 'rounded-circle' : 'rounded-0', 'avatar-xl', 'ms-4']"
      alt="Student Photo"
  :style="{
    border: '3px solid ' + Obj1.idCardData?.sidebarFooterColor,
    background: '#fff'
  }"    />

    <p class="academic-year text-center small ms-4">
      {{ academicYear }}
    </p>

    <p
      class="name-a rounded w-75 ms-5 mt-n3"
  :style="{
    backgroundColor: Obj1.idCardData?.nameBgColor1,
    color: Obj1.idCardData?.nameColor1
  }"    >
      {{ stu.firstName }} {{ stu.lastName }}
    </p>

    <div class="ms-4 mt-n2">
      <div class="row mb-1 align-items-start">
        <div class="col-md-3 col-lg-2 text-start text-nowrap"><strong>Class</strong></div>
        <div class="col text-start ms-50">
          : {{ (classList || []).find(c => c._id === clsID)?.name || '' }}
          <span v-if="stu.sectionID">
            ({{ (secList || []).find(sec => sec._id == stu.sectionID)?.Name || '' }})
          </span>
        </div>
      </div>

      <div class="row mb-1 align-items-start">
        <div class="col-md-3 col-lg-2 text-start text-nowrap"><strong>Contact No</strong></div>
        <div class="col text-start ms-50">: {{ stu.parent?.phone }}</div>
      </div>
        <div class="row mb-1 align-items-start" v-if="stu.dob">
    <div class="col-md-3 col-lg-2 text-start text-nowrap me-2"><strong>Date of Birth</strong></div>
    <div class="col text-start ms-50">: {{ disDate(stu.dob) }}</div>
  </div>
        <div class="row mb-1 align-items-start">
    <div class="col-md-3 col-lg-2 text-start text-nowrap"><strong>Address</strong></div>
    <div class="col text-start ms-50"><span class="address-wrap">: {{ stu.parent?.address }}</span></div>
  </div>
    </div>
  </div>

  <div class="wave-bottom" style="bottom: -80px" >
    <p class="text-end me-2">PRINCIPAL</p>
    <div class="print-footer"   :style="{
    backgroundColor: Obj1.idCardData?.sidebarFooterColor,
    height: '8px',
    width: '100%',
    borderRadius: '0 0 10px 10px'
  }"></div>
  </div>
  <div class="footer"   :style="{
    backgroundColor: Obj1.idCardData?.sidebarFooterColor,
    height: '25px'
  }"></div>
</div>
<!--idcard 2-->

<div v-else-if="primaryCard === 'idCard2'" class="id-card">
  <!-- Top SVG wave (static red) -->
  <div class="wave-top" style="height:131px; margin-top: -6px; overflow:hidden;">
    <svg viewBox="0 0 500 150" preserveAspectRatio="none" style="position:absolute; left:0; top:0; width:100%; height:100%;">
      <path d="M0,80 C80,10 320,120 500,50 L500,0 L0,0 Z"  :style="{ fill: Obj2.idCardData?.waveTopColor1 }"></path>
      <path d="M0,100 C100,40 300,140 500,60 L500,0 L0,0 Z" :style="{ fill: Obj2.idCardData?.waveTopColor2, opacity: 0.85 }"></path>
    </svg>
  </div>
  <div class="card-content2 text-center">
    <div class="d-flex align-items-start mt-2 start-a">
      <img :src="getUrl(profile.Image, logo_default)" alt="School Logo" class="logo ms-2 mt-2" width="55" height="55" />
      <div class="text-start w-100 mt-2 me-1">
        <p class="text-center fw-bold mb-0 me-1"  :style="{color: Obj2.idCardData?.nameColor2  }">{{ profile.Name }}</p>
        <p class="text-center me-1 small mb-0"  :style="{ color: Obj2.idCardData?.nameColor2 }">{{ profile.Address }}</p>
      </div>
    </div>
        <img
      :src="getUrl(stu.image, profile_default)"
  :class="[
    Obj2.idCardData?.imageShape === 'circle'
      ? 'rounded-circle'
      : 'rounded-0',
    'avatar-xl',
    'bg-white'
  ]"
  :style="{ border: '3px solid ' + Obj2.idCardData?.waveTopColor2 }"
       alt="Student Photo"
    />
 <p class="fw-bold">{{ academicYear }}</p>
    <h4 class="name-a rounded w-75 ms-4 mt-n3"  :style="{ backgroundColor: Obj2.idCardData?.waveTopColor2, color: Obj2.idCardData?.nameColor2 }">{{ stu.firstName }} {{ stu.lastName }}</h4>
         <div class="row mb-1 align-items-start ms-2">
        <div class="col-md-3 col-lg-2 text-start text-nowrap"><strong>Class</strong></div>
        <div class="col text-start ms-50">
          : {{ (classList || []).find(c => c._id === clsID)?.name || '' }}
          <span v-if="stu.sectionID">
            ({{ (secList || []).find(sec => sec._id == stu.sectionID)?.Name || '' }})
          </span>
        </div>
      </div>
              <div class="row mb-1 align-items-start ms-2" v-if="stu.dob">
    <div class="col-md-3 col-lg-2 text-start text-nowrap"><strong>Date of Birth</strong></div>
    <div class="col text-start ms-50">: {{ disDate(stu.dob) }}</div>
  </div>
      <div class="row mb-1 align-items-start ms-2">
        <div class="col-md-3 col-lg-2 text-start text-nowrap"><strong>Contact No</strong></div>
        <div class="col text-start ms-50">: {{ stu.parent?.phone }}</div>
      </div>  
  </div>


  <!-- Bottom SVG wave (static red) -->
  <div class="wave-bottom " style="height:100px;bottom: 0px; overflow:hidden;">
        <p class="text-end position-absolute" style="right:8px; top:15px;">PRINCIPAL</p>
    <svg viewBox="0 0 500 150" preserveAspectRatio="none" style="position:absolute; left:0; top:0; width:100%; height:100%;">
      <path d="M0,60 C150,150 350,-30 500,70 L500,150 L0,150 Z"   :style="{ fill: Obj2.idCardData?.waveBottomColor1 }"></path>
      <path d="M0,80 C180,160 320,-20 500,90 L500,150 L0,150 Z" :style="{ fill: Obj2.idCardData?.waveBottomColor2, opacity: 0.85 }"></path>
    </svg>
  </div>
</div>
<!--idcard 3-->

<div v-else-if="primaryCard === 'idCard3'" class="id-card">
  <!-- Top SVG waves (static) -->
  <div class="wave-top top-0" style="height:105px; overflow:hidden;">
    <svg viewBox="0 0 500 150" preserveAspectRatio="none" class="d-block w-100 h-100" style="position:absolute; inset:0;">
      <path d="M900 120 C100 10 200 150 0 150 L0 50 L400 0 Z" :style="{ fill: Obj3.idCardData?.waveTopColor2 }"></path>
      <path d="M-90 0 C300 30 300 200 900 150 L900 50 L500 0 Z" :style="{ fill: Obj3.idCardData?.waveTopColor2 }"></path>
      <path d="M0 120 C800 60 600 200 900 40 L500 0 L0 0 Z" :style="{ fill: Obj3.idCardData?.waveTopColor1 }"></path>
    </svg>
  </div>

  <div class="card-content3 text-center">
    <div class="d-flex align-items-start mt-1">
      <img :src="getUrl(profile.Image, logo_default)" alt="School Logo" class="logo ms-2 mt-2" width="55" height="55" />
      <div class="text-start w-100 mt-2 me-1">
        <p class="text-center fw-bold mb-0 me-1"  :style="{ color: Obj3.idCardData?.nameColor2 }">{{ profile.Name }}</p>
        <p class="text-center me-1 small mb-1 "  :style="{ color: Obj3.idCardData?.nameColor2 }">{{ profile.Address }}</p>
      </div>
    </div>

    <img :src="getUrl(stu.image, profile_default)" :class="[ Obj3.idCardData?.imageShape === 'circle' ? 'rounded-circle' : 'rounded-5', 'avatar-xxl', 'bg-white' ]" :style="{ border: '5px solid ' + Obj3.idCardData?.waveTopColor1 }" alt="Student Photo" />

    <h2 class="mt-1">{{ stu.firstName }} {{ stu.lastName }}</h2>

    <p class="text-black small px-2 mt-n2">
      {{ academicYear }}
    </p>
<div class="ms-3 mt-n3">
  <div class="row mb-1 align-items-start">
    <div class="col-4 text-start text-nowrap">
      <strong>Contact No</strong>
    </div>
    <div class="col-8 text-start text-break">
      : {{ stu.parent?.phone }}
    </div>
  </div>

  <div class="row mb-1 align-items-start">
    <div class="col-4 text-start text-nowrap">
      <strong>Address</strong>
    </div>
    <div class="col-8 text-start text-break">
      : {{ stu.parent?.address }}
    </div>
  </div>
</div>


</div>

  <!-- Bottom SVG waves (static) -->
  <div class="wave-bottom bottom-0" style="height:100px; overflow:hidden;">
    <p class="text-end position-absolute" style="right:8px; top:26px;">PRINCIPAL</p>
    <svg viewBox="0 0 500 150" preserveAspectRatio="none" class="d-block w-100 h-100" style="position:absolute; inset:0;">
      <path d="M0,85 C140,53 320,20 460,150 L0,150 Z"  :style="{ fill: Obj3.idCardData?.waveBottomColor1 }"></path>
      <path d="M0,80 C106,208 320,40 500,50 L500,150 L0,150 Z" :style="{ fill: Obj3.idCardData?.waveBottomColor2 }"></path>
    </svg>
  </div>
</div>
<!--idcard 4-->
<div v-else-if="primaryCard === 'idCard4'" class="id-card">

                <div class="wave-top">
<svg viewBox="0 0 390 200" xmlns="http://www.w3.org/2000/svg">
  <!-- top bar -->
  <path d="M0 0 L390 0 L390 25 L0 25 Z"  :style="{ fill: Obj4.idCardData?.waveTopColor1 }" />
  <g transform="translate(0,48) scale(1,-1)">
    <!-- main large polygon -->
    <polygon points="0,-25 130,-25 108,48 0,48" :style="{ fill: Obj4.idCardData?.waveTopColor3 }" />
    <!-- second polygon -->
    <polygon points="82,-35 151,-35 130,5 60,5" :style="{ fill: Obj4.idCardData?.waveTopColor3 }" />
    <!-- small overlay polygon -->
    <polygon points="77,-25 126,-25 110,6 60,6"  :style="{ fill: Obj4.idCardData?.waveTopColor2 }" />
    <!-- start-left polygon -->
    <polygon points="-10,-35 50,-35 30,5 -10,5" :style="{ fill: Obj4.idCardData?.waveTopColor3 }" />
    <!-- small start-left overlay -->
    <polygon points="-15,-25 40,-25 25,6 -15,6" :style="{ fill: Obj4.idCardData?.waveTopColor2 }" />
    <!-- third polygon to the right -->
    <polygon points="142,6 194,6 174,36 120,36" :style="{ fill: Obj4.idCardData?.waveTopColor2 }" />
  </g>
</svg>
                </div>

                <div class="card-content4">
                  <div class="text-center">
                    <img :src="getUrl(profile?.Image, logo_default)"
                         class="avatar-sm mt-2"
                         crossorigin="anonymous" />
                    <p class="fw-bold mb-0">{{ profile?.Name }}</p>
                  </div>

                  <img
                    :src="getUrl(stu.image, profile_default)"
  :class="[
    Obj4.idCardData?.imageShape === 'circle'
      ? 'rounded-circle'
      : 'rounded-0',
    'avatar-xxl',
    'bg-white',
    'stu-photo'
  ]"
  :style="{
    border: '5px solid ' + Obj4.idCardData?.waveTopColor1
  }"                    crossorigin="anonymous"
                  />

                  <h2 class="text-center text-dark">
                    {{ stu.firstName }} {{ stu.lastName }}
                  </h2>
<div class="year-wrap my-2">
  <p class="text-center fw-bold text-white w-75 p-1 year-pill text-nowrap d-inline-block" :style="{ backgroundColor: Obj4.idCardData?.waveTopColor3 }">
    {{ academicYear }}
  </p>
  <svg height="30" width="30" class="mt-n1" aria-hidden="true">
    <line x1="10" y1="0" x2="10" y2="31" stroke-width="8" stroke-linecap="round" :stroke="Obj4.idCardData?.waveTopColor3" />
    <line x1="22" y1="0" x2="22" y2="31" stroke-width="8" stroke-linecap="round" :stroke="Obj4.idCardData?.waveTopColor3" />
  </svg>
</div>

                  <div class="text-center">
                    <strong>Contact :</strong>
                    {{ stu.parent?.phone || '-' }}
                  </div>
                  <p class="text-center small mt-3">+{{ profile.MobileNo }} <br>
  <a href="https://schoolsmanagement.com/" class="text-center text-dark small" target="_blank">WWW.Schoolsmanagement.com</a></p>
                </div>

                <div class="wave-bottom">
<svg width="100%" height="190" viewBox="0 0 1080 190" xmlns="http://www.w3.org/2000/svg">
  <!-- background bar -->
  <rect x="0" y="50" width="1080" height="200"  :style="{ fill: Obj4.idCardData?.waveTopColor3 }"/>
  <!-- left slanted block -->
  <polygon points="0,50 190,50 120,180 0,180" :style="{ fill: Obj4.idCardData?.waveTopColor1 }"/>
  <!-- divider line -->
  <line x1="200" y1="50" x2="130" y2="185" stroke="#C4C4C4" stroke-width="20"></line>
  <!-- right big slanted block -->
  <polygon points="1080,110 820,110 760,190 1080,190"  :style="{ fill: Obj4.idCardData?.waveTopColor2 }"/>
  <!-- right inner slanted block (new) -->
  <polygon points="780,110 640,110 580,190 720,190" :style="{ fill: Obj4.idCardData?.waveTopColor2 }"/>
</svg>
                </div>
              </div>
            </div>

            <!-- PAGE BREAK AFTER 6 -->
<div
  v-if="pIndex < studentPages.length - 1"
  class="page-break"
></div>
     </div>
        </div>
</div>
      </div>
    </div>

  </div>
</template>

<script setup>
import { ref, computed, nextTick,onMounted,watch } from 'vue'
import { formatDate,api } from '@/utils/helpers'
import { schoolStore } from '@/utils/schoolStore'
import { isRequired, validateForm } from '@/utils/validation.js';
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'
const errors = ref({})
const store = schoolStore()
const Obj1 = ref({})
const Obj2 = ref({})
const Obj3 = ref({})
const Obj4 = ref({})
const disDate = d => formatDate(d);
const sidebarBg = computed(() => {
  const color = Obj1.value.idCardData.sidebarFooterColor.replace('#', '%23');
return `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='30' height='500'><polygon points='0,0 30,0 5,500 0,500' style='fill:${color};stroke:white;'/></svg>") no-repeat`;
});
const cardsReady = ref(false)
const primaryCard = computed(() => {
  if (Obj1.value.idCardData?.primary) return 'idCard1'
  if (Obj2.value.idCardData?.primary) return 'idCard2'
  if (Obj3.value.idCardData?.primary) return 'idCard3'
  if (Obj4.value.idCardData?.primary) return 'idCard4'
  return null
})

const classList = computed(() => {
  const list = store.clsList
  return Array.isArray(list?.value)
    ? list.value
    : Array.isArray(list)
      ? list
      : []
})
watch(primaryCard, v => {
  console.log('PRIMARY CARD SELECTED:', v)
})
const studentPages = computed(() => {
  const pages = []
  for (let i = 0; i < students.value.length; i += 6) {
    pages.push(students.value.slice(i, i + 6))
  }
  return pages
})

const secList = store.secList
const profile = store.profile
const clsID = ref('')
const sectionID = ref('')
const students = ref([])
const loaded = ref(false)
const printSection = ref(null)

const logo_default = '/images/Logo.png'
const profile_default = '/images/default.png'

const academicYear = computed(() => {
  const y = new Date().getFullYear()
  return `${y}-${y + 1}`
})
const selectClass = (item) => {
  clsID.value = item._id
  sectionID.value = ''
}
const uniqueClassList = computed(() => {
  const map = new Map()

  classList.value.forEach(cls => {
    if (!cls?.name) return

    const key = cls.name.trim().toLowerCase()

    if (!map.has(key)) {
      map.set(key, cls)
    }
  })

  return [...map.values()]
})

const getCardByStudent = async () => {
  try {
    const res = await api.get('/idcards/all', { params: { name: 'student' } })

    const studentCards = Array.isArray(res.data)
      ? res.data.filter(c => c.name === 'student')
      : []

    console.log('STUDENT ID CARDS:', studentCards)

    // reset
    Obj1.value = {}
    Obj2.value = {}
    Obj3.value = {}
    Obj4.value = {}

    // map cards
    studentCards.forEach(card => {
      const cardName = card.idCardData?.name

      if (cardName === 'idCard1') Obj1.value = card
      if (cardName === 'idCard2') Obj2.value = card
      if (cardName === 'idCard3') Obj3.value = card
      if (cardName === 'idCard4') Obj4.value = card
    })

    // defaults
    Obj1.value.idCardData ??= { name: 'idCard1', primary: false }
    Obj2.value.idCardData ??= { name: 'idCard2', primary: false }
    Obj3.value.idCardData ??= { name: 'idCard3', primary: false }
    Obj4.value.idCardData ??= { name: 'idCard4', primary: false }

    enforceSinglePrimary()
    cardsReady.value = true
  } catch (err) {
    console.error('ID Card API error:', err)
  }
}

const enforceSinglePrimary = () => {
  const all = [
    Obj1.value.idCardData,
    Obj2.value.idCardData,
    Obj3.value.idCardData,
    Obj4.value.idCardData
  ].filter(Boolean)

  // normalize primary to boolean
  all.forEach(c => {
    c.primary =
      c.primary === true ||
      c.primary === 'true' ||
      c.primary === 1 ||
      c.primary === '1'
  })

  const primaryCards = all.filter(c => c.primary)

  // multiple primary → keep first
  if (primaryCards.length > 1) {
    all.forEach(c => (c.primary = false))
    primaryCards[0].primary = true
  }

  // none primary → fallback
  if (primaryCards.length === 0 && Obj4.value.idCardData) {
    Obj4.value.idCardData.primary = true
  }
}



const loadStudents = async () => {

  const fields = {
    Class: {
      value: clsID.value,
      validators: [isRequired]
    }
  }

  errors.value = validateForm(fields)

  if (Object.keys(errors.value).length > 0) {
    return
  }
  students.value = []
  loaded.value = false
  try {
    const sections = Array.isArray(secList) ? secList
      : Array.isArray(secList?.value) ? secList.value : []

    if (sectionID.value) {
      const res = await api.get(`/students/clssection/${clsID.value}/${sectionID.value}`)
      students.value = Array.isArray(res.data) ? res.data : []
    } else {
      let allStudents = []
      for (const sec of sections) {
        const res = await api.get(`/students/clssection/${clsID.value}/${sec._id}`)
        if (Array.isArray(res.data)) allStudents.push(...res.data)
      }
      students.value = allStudents
    }
  } catch (err) {
    console.error('Student load error', err)
  }
  loaded.value = true
}
const reset = () => {
  clsID.value = ''
  sectionID.value = ''
  students.value = []
  errors.value = {}
}

const getUrl = (img, fallback) => {
  if (!img) return fallback
  const base =
    import.meta.env?.VITE_APP_API_URL ||
    process.env?.VUE_APP_API_URL ||
    ''
  if (!base) return img
  return img.startsWith('http') ? img : `${base}${img}`
}

const printSectionOnly = async () => {
  await nextTick()
  window.print()
}

const downloadImage = async () => {
  await nextTick()

  const pdf = new jsPDF({
    orientation: 'portrait',
    unit: 'pt',
    format: 'a4'
  })

  const pages = printSection.value.children

  for (let i = 0; i < pages.length; i++) {
    const canvas = await html2canvas(pages[i], {
      scale: 2,
      useCORS: true,
      backgroundColor: '#fff'
    })

    const imgData = canvas.toDataURL('image/png')

    const pageWidth = pdf.internal.pageSize.getWidth()
    const pageHeight = (canvas.height * pageWidth) / canvas.width

    if (i > 0) pdf.addPage()
    pdf.addImage(imgData, 'PNG', 0, 0, pageWidth, pageHeight)
  }

  pdf.save(`ID-Cards-${academicYear.value}.pdf`)
}

onMounted(async () => {
  await getCardByStudent()
})
</script>

<style scoped>
.a4-sheet {
  width: 210mm;
  height: 277mm;
  background: #fff;
  padding: 10mm;
  box-sizing: border-box;
  overflow: hidden;
}
.scrollable-menu {
  max-height: 200px;
  overflow-y: auto;
}

.scale-wrap {
  transform-origin: top center;
  display: flex;
  justify-content: center;
}

.print-capture .scale-wrap {
  transform: none !important;
}

.id-card {
  position: relative;
  width: 300px;
  height: 420px;
  border: 1px solid #ddd;
  border-radius: 10px;
  background: #fff;
  overflow: hidden;
}
.card-content4 {
margin-top: -80px;
    position: relative;
    z-index: 2;
  }
  .card-content3 {
margin-top: -112px;
    position: relative;
    z-index: 2;
  }
.card-content2 {
margin-top: -112px;
    position: relative;
    z-index: 2;
  }
.academic{
  margin-top:-8px
}
.stu-photo {
  border: 5px solid #073655;
  display: block;
  margin: 8px auto 12px auto;
}

.wave-top,
.wave-bottom {
  position: absolute;
  left: 0;
  right: 0;
}

.wave-top { top: 0; height: 90px; }
.wave-bottom { bottom: 0; height: 113px; }

.page-break {
  page-break-after: always;
}
@media print {

  body * {
    visibility: hidden !important;
  }
  .print-target,
  .print-target * {
    visibility: visible !important;
  }
    .avatar-xl,
  .avatar-xxl,
  .stu-photo {
    margin-top: 4px !important;
  }
  .a4-sheet {
    padding: 4mm !important;
  }
  .scale-wrap {
    transform: none !important;
        justify-content: flex-start !important;
  }
  .row {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  [class^="col-"] {
    padding-left: 4px !important;
    padding-right: 4px !important;
  }

  .idcard-col {
    margin-bottom: 6px !important;
  }
  .print-target {
    position: absolute !important;
    inset: 0 !important;
    width: 100% !important;
    background: #fff !important;
    z-index: 9999 !important;
  }

  .year-wrap {
    width: 100% !important;
    text-align: center !important;
  }

  .year-wrap .year-pill {
    display: inline-block !important;
    white-space: nowrap !important;
  }

  .year-wrap svg {
    vertical-align: middle !important;
    margin-left: 6px !important;
  }

  .year-wrap .year-svg line {
    stroke-width: 8 !important;
    vector-effect: non-scaling-stroke !important;
  }
  .id-card .card-content3 .ms-2 {
    margin-left: 0 !important;
  }
  @page {
    size: A4;
    margin: 8mm;
  }

  * {
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
}
.page-wrapper {
  width: 100%;
}

</style>
